<template>
    <div class="marginCon">
        <Card>



            <!-- 搜索 -->
            <div class="search-div flexC"  v-if="offModel">

                <div class="search-div-item flexC">
                    <div class="labelText">{{ $t("appDevice.titleName.pageId") }}</div>
                    <Input class="input-div" :placeholder='$t("inputPlaceholder")' clearable
                        v-model="searchObj.pageId"></Input>
                </div>

                <div class="search-div-item flexC">
                    <div class="labelText">{{ $t("appDevice.titleName.status") }}</div>
                    <Select :placeholder='$t("selectPlaceholder")' clearable class="input-div"
                        v-model="searchObj.versionStatus">
                        <Option value="1">{{ $t("selectList.appStatusList.Online") }}</Option>
                        <Option value="2">{{ $t("selectList.appStatusList.Expired") }}</Option>
                    </Select>
                </div>

                <div class="search-div-item flexC">
                    <div class="labelText">{{ $t("appPlan.titleName.os") }}</div>
                    <Select :placeholder='$t("selectPlaceholder")' clearable class="input-div" v-model="searchObj.os">
                        <Option value="1">android</Option>
                        <Option value="2">ios</Option>
                    </Select>
                </div>


                <div class="search-div-item">
                    <Button type="info" @click="getData" icon="ios-search"
                        style="marginTop:5px;height:44px;line-height:44px;width:96px;border-radius: 10px;">{{ $t('search')
                        }}</Button>
                </div>

            </div>

            <!-- 新增 -->
            <div v-if="offModel">
                <div class="top" v-if='roleType == 1'>
                    <Button type="success" class="addButton" @click="addData(1)" style="margin-right:8px;">{{
                        $t("appDevice.addButton") }}</Button>
                </div>

                <Table style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"
                    ref="selection" @on-sort-change="sortCustom" :loading='loading'></Table>
                <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer
                    :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10, 15, 20]"
                    placement="top" class="pages" />
            </div>

            <!-- 更改状态弹框组件 -->
            <ChangeDialog ref="changeChild" @ievent="ievent(1)" :title='$t("appVersion.deletModel.changeTitle")'
                :cont='$t("appVersion.deletModel.changeCont")'></ChangeDialog>

            <!-- 编辑 / 添加  模态框组件 -->
            <ModelBox :showModel.sync="addBox.showModel" :offModel.sync='offModel' :fn="addBox.callbackFn" :type="type"
                :editFormData="addBox.editFormData"></ModelBox>

            <!-- 删除弹框组件 -->
            <ChangeDialog ref="deleteChild" @ievent="ievent(2)" :title='$t("orderManage.deletModel.changeTitle")'
                :cont='$t("orderManage.deletModel.changeCont")'></ChangeDialog>

        </Card>
    </div>
</template>

<script>

import common from '@/common/common.js';
import ChangeDialog from '../common/deleteModel.vue'; // 引入删除弹框组件
import ModelBox from './component/deviceAddModel.vue';
import moment from 'moment'; // 引入删除弹框组件
import { mapState } from 'vuex'
export default {
    name: "pageVersion",
    components: {
        ChangeDialog,
        ModelBox
    },
    data() {
        return {
            loading: true,
            offModel: true,
            type: 1,
            page: {//分页排序
                total: 0,//总条数
                pageSize: 15,//每页条数
                current: 1,//当前页
            },
            addBox: {//规格弹框组-新增
                showModel: false,//弹框开关
                callbackFn: () => { }, //弹框的回调函数
                editFormData: {},//编辑时传入的现有数据
            },
            tableList: {
                tableData: [],
                hasSelectData: {}
            },
            searchObj: {
                pageId: "",
                versionStatus: "",
                os: ""
            }
        }
    },
    computed: {
        ...mapState(['local', 'selectId']),
        roleType() {
            let res = '2'
            if (this.$store.state.uInfo && this.$store.state.uInfo.roleType) {
                res = this.$store.state.uInfo.roleType
            }
            return res
        },
        titleName() {
            return [
                {
                    title: this.$t('appDevice.titleName.id'),
                    'title-zh-CN': '序号',
                    'title-en-US': 'Id',
                    key: 'id',
                    minWidth: 120,
                    sortable: true,
                    tree: true
                },
                {
                    title: this.$t('appDevice.titleName.pageId'),
                    'title-zh-CN': '页面编号',
                    'title-en-US': 'pageId',
                    key: 'pageId',
                    minWidth: 110
                },
                {
                    title: this.$t('appDevice.titleName.pageVersion'),
                    'title-zh-CN': '页面版本',
                    'title-en-US': 'pageVersion',
                    key: 'pageVersion',
                    minWidth: 110
                },
                {
                    title: this.$t('appDevice.titleName.appVersion'),
                    'title-zh-CN': 'app版本',
                    'title-en-US': 'appVersion',
                    key: 'appVersion',
                    minWidth: 110
                },
                {
                    title: this.$t('appVersion.titleName.releaseDate'),
                    'title-zh-CN': '发布日期',
                    'title-en-US': 'releaseDate',
                    key: 'releaseDate',
                    minWidth: 180,
                    render: (h, params) => {
                        let stext = moment(params.row.releaseDate * 1).format('YYYY-MM-DD')
                        return h('div', stext || '')
                    }
                },

                {
                    title: this.$t('appPlan.titleName.releaseType'),
                    'title-zh-CN': '发布类型',
                    'title-en-US': 'Release type',
                    key: 'releaseType',
                    minWidth: 130,
                    render: (h, params) => {
                        let obj = { '0': this.$t("selectList.releaseTypeList.beta"), '1': this.$t("selectList.releaseTypeList.release") }
                        let stext = obj.hasOwnProperty(params.row.releaseType) ? obj[params.row.releaseType] : params.row.releaseType
                        return h('div', stext || '')
                    }
                },
                {
                    title: this.$t('appDevice.titleName.status'),
                    'title-zh-CN': '状态',
                    'title-en-US': 'versionStatus',
                    key: 'versionStatus',
                    minWidth: 110,
                    render: (h, params) => {
                        let obj = { '1': this.$t("selectList.appStatusList.Online"), '2': this.$t("selectList.appStatusList.Expired") }
                        let stext = obj.hasOwnProperty(params.row.versionStatus) ? obj[params.row.versionStatus] : params.row.versionStatus
                        let color = params.row.versionStatus == 1?'#19be6b':'#333'

                        return h('div',{style:{color:color}}, stext || '')
                    }
                },
                {
                    title: this.$t('appPlan.titleName.os'),
                    'title-zh-CN': '系统',
                    'title-en-US': 'Operational',
                    key: 'os',
                    minWidth: 120,
                    render: (h, params) => {
                        let obj = { '1': 'android', '2': 'ios' }
                        let stext = obj[params.row.os]
                        return h('div', stext || '')
                    }
                },
                {
                    title: this.$t('appVersion.titleName.fileName'),
                    'title-zh-CN': '包文件',
                    'title-en-US': 'Apk file ',
                    key: 'fileId',
                    minWidth: 240
                },
                {
                    title: this.$t('appVersion.titleName.updateInformation'),
                    'title-zh-CN': '更新信息',
                    'title-en-US': 'Update information',
                    key: 'versionInformation',
                    resizable: true,
                    // width:160,
                    minWidth: 300,
                    render: (h, params) => {
                        let flag = params.row.versionInformation;
                        let flag1 = flag.slice(2, flag.length - 2);
                        let arr = flag1.split('&&')
                        let stext = ''
                        arr.map((item, index) => {
                            let indexflag = item.indexOf('&')
                            if ((this.local == 'zh-CN' && item.slice(0, indexflag) == 'zh') || (this.local == 'en-US' && item.slice(0, indexflag) == 'en')) {
                                stext = (item.split('&'))[1]
                            }

                        })

                        return h('div', {
                            attrs: {
                                title: stext
                            }
                        }, stext || '')
                    }
                },
                {
                    title: this.$t('appPlan.titleName.Operation'),
                    'title-zh-CN': '操作',
                    'title-en-US': 'Operation',
                    minWidth: this.roleType == 1 ? 160 : 110,
                    key: "id",
                    // fixed:'right',
                    render: (h, params) => {
                        let that = this

                        return [h('div',
                            {
                                style: {
                                    display: "flex",
                                    justifyContent: 'center'
                                }
                            }, [
                            h('Button', {
                                props: {
                                    type: "error",
                                    size: 'small'
                                },
                                style: {
                                    'margin-right': '5px',
                                    'display': this.roleType == 1 ? 'block' : 'none'
                                },
                                on: {
                                    click: () => { this.changeStatus(params.row, 'deleteChild') }
                                }
                            }, that.$t("delete")),
                            h('Button', {
                                props: {
                                    type: "info",
                                    size: 'small'
                                },
                                style: {
                                    'margin-right': '5px',
                                    'display': this.roleType == 1 ? 'block' : 'none'
                                },
                                on: {
                                    click: () => { this.addData(2, params.row) }
                                }
                            }, that.$t("edit")),
                            h('Button', {
                                props: {
                                    type: "primary",
                                    size: 'small'
                                },
                                attrs: {
                                    disabled: params.row.versionStatus == 2 ? true : false
                                },
                                style: {
                                    'margin-right': '8px'
                                },
                                on: {
                                    click: () => {
                                        this.tableList.hasSelectData = params.row
                                        this.changeStatus(params.row, 'changeChild')
                                    }
                                }
                            }, that.$t("appVersion.Expire"))
                        ]
                        )]
                    }
                }
            ]
        }
    },
    created() {

        this.getData()
    },

    methods: {
        addData(type, item = {}) {  //添加或编辑数据
            if (this.roleType == 2) return
            this.addBox.showModel = true
            this.offModel = false
            this.type = type
            if (type == 2) {
                this.addBox.editFormData = item
            }
            this.addBox.callbackFn = () => {//回调处理
                //重新载入
                // this.clearbtnStatus()
                this.addBox.showModel = false;
                this.getData();
            }
        },
        changeStatus(item, type) {//更改状态
            this.tableList.hasSelectData = item;
            this.$refs[type].showit();
        },
        ievent(type) {// 更改状态
            // console.log('更改状态',this.tableList.hasSelectData.id)

            if (type == 1) { //过期
                let getData = {
                    id: this.tableList.hasSelectData.id,
                    whetherRun: !this.tableList.hasSelectData.whetherRun,
                    dealerId: this.selectId
                }
                this.axios.post(this.config.urlArray.pageVersionExpire, getData).then((result) => {
                    common.ajaxMsg(result.data, true, () => {
                        this.$refs.changeChild.recancel();
                        this.getData();
                    })
                }).catch((err) => {
                    // common.msg('error','删除失败')
                })

            } else if (type == 2) { //删除
                if (this.roleType == 2) return
                this.axios.post(this.config.urlArray.pageVersionDel, { id: this.tableList.hasSelectData.id, dealerId: this.selectId }).then((result) => {
                    common.ajaxMsg(result.data, true, () => {
                        this.$refs.deleteChild.recancel();
                        this.getData();
                    })
                }).catch((err) => {
                    // common.msg('error','删除失败')
                })

            }

        },
        getData() { //获取数据
            let params = {
                page: this.page.current,
                limit: this.page.pageSize,
                dealerId: this.selectId
            }

            Object.assign(params,this.searchObj)

            console.log(Object.assign(params,this.searchObj))

            this.axios.post(this.config.urlArray.pageVersionList, params).then((result) => {
                common.ajaxMsg(result.data, false, () => {
                  
                    let resData = result.data.data

                    console.log('resData',resData)
                    //处理数组
                    if (resData) {
                        this.tableList.tableData = resData.pageVersionList  //渲染数据
                        this.page.total = resData.meta.count
                        this.loading = false
                    } else {
                        this.tableList.tableData = []
                        this.page.total = 0
                        this.loading = false
                        return false
                    }
                });
            }).catch((err) => {
                // common.msg('error','获取失败',()=>{})
            });
        },
        sortCustom(data) {//自定义排序
            this.page.key = data.key
            this.page.order = data.order
            this.getData()
        },
        changePage(nowpage) {//切换分页
            this.page.current = nowpage
            this.getData()
        },
        changeSize(nowSize) {//切换每页显示条数
            this.page.pageSize = nowSize
            this.page.current = 1
            this.getData()
        }
    }
}
</script>

<style  scoped lang="less">
.labelText {
    line-height: 54px;
    height: 54px;
    flex-shrink: 0;
    margin-right: 10px;
}

.search-div {
    flex-wrap: wrap;
    background-color: #fff;
    //  padding: 34px 40px ;
    background: #FFFFFF;
    //  margin: 20px 40px;
    border-radius: 14px;

    .search-div-item {
        margin-right: 20px;

        span {
            margin-right: 30px;
        }
    }

    /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
    .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        height: 44px;
        line-height: 44px;
    }

    /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        height: 44px;
        line-height: 44px;
    }

    /deep/ .ivu-select-single .ivu-select-selection {
        height: 44px;
        width: 200px;
    }

    /deep/ .ivu-input {
        height: 44px;
        line-height: 44px;
    }

    /deep/ .ivu-input-icon {
        height: 44px;
        line-height: 44px;
    }

    /deep/ .ivu-select-input {
        height: 44px;
        line-height: 44px;
    }
}</style>



